import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Dropdown, Image, message, Select, Modal, Switch } from 'antd';
import { TableGrid } from '../../../Component/Table';
import './style.scss'
import Api from '../../../Network/ApiConfig'
import { DownOutlined, EditOutlined, DeleteOutlined, ExclamationCircleOutlined } from '@ant-design/icons'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import en from "../../../localization/en";
import ar from "../../../localization/ar";
import { useSelector } from 'react-redux';
const { Option } = Select
const { confirm } = Modal;

export const FAQ = () => { 
  const history = useHistory();
  const {  currentLang } = useSelector((state) => state?.user);

  const t = currentLang === "en" ? en : ar;

const handelDltRowData = (Id) => {
  confirm({
    title: `${t.DoyouWanttodeletethis} ${t.FAQ}?`,
    // title: localization.DodeletetheseAddress[this.props.currentLang], 
    icon: <ExclamationCircleOutlined />,
    okText: t.Ok,
    cancelText: t.Cancel,
    onOk: () => {
      setLoading(true)
      Api.get(`AdminAPIs/DeleteFAQ?FAQId=${Id}`).then(res => {
        if (res?.status === 200) {
          // setLeadsList(res?.data?.model);
          // setLeadsListFiltered(res?.data?.model);
          message.success(res?.data?.metas?.message);
          fetchLeedsList(); 
        }
      }, (err) => {
        setLoading(false)
      })
      },
      onCancel() {
        
      },
    });
  };




  const pdfRef = React.createRef()
  const [leadsList, setLeadsList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [leadsListFiltered, setLeadsListFiltered] = useState([]);
  // const [pdfTableColumns, setPdfTableColumns] = useState(pdfColumns);


  const fetchLeedsList = (url, pageSize) => {
    
    setLoading(true);

      Api.get('AdminAPIs/GetFAQs?page=0').then(res => {
        if (res?.status === 200) {
          setLeadsList(res?.data?.model);
          setLeadsListFiltered(res?.data?.model); 
        }
        setLoading(false)
      }, (err) => {
        setLoading(false)
      })
  }

  useEffect(() => {
    fetchLeedsList()
  }, [currentLang]);


  const columns = [
    {
      title: <p className='table-header-text'> # </p>,
      dataIndex: 'Id',
    },
    {
      title: <p className='table-header-text'> {t.name}</p>,
            dataIndex: currentLang === "en" ? "Name" : "NameLT",

    },
    {
      title: <p className='table-header-text'> {t.FAQCategories}</p>,
      render: (_, record) => <span>{ currentLang === "en" ? record?.FAQCategory?.Name : record?.FAQCategory?.NameLT} </span>,
    },
    {
      title:  <p className='table-header-text'> {t.Actions}</p>,
      dataIndex: '',
      render: (_, record) => {
        return (
          <div className="select-item-action"> 
            <EditOutlined onClick={(e) => {
              e.stopPropagation();
              e.preventDefault(); 
              // handelEditRowData(record?.Id);
              history.push({ pathname: '/add-faq', state: record })
            }} style={{ marginInlineEnd: 20, fontSize: 20, cursor: "pointer" }} />
            <DeleteOutlined onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              handelDltRowData(record?.Id);
            }
            } style={{ marginInlineEnd: 20, color: 'red', fontSize: 20, cursor: "pointer" }} />
          </div>
        );
      },
    },
  ];

  return (
    <div>
      <TableGrid TableRef={pdfRef} 
      title={
        <div className='table__filter'>
          <p style={{ fontWeight: 'bold' }}>{t.FAQ}</p>

          <div className='product__btn'>
            <Button onClick={() => history.push('/add-faq')} className='primary'>{t.NewFAQ} </Button>
          </div>
        </div>
      }
        columns={columns || []}
        dataSource={leadsList || []}
        pagination={{ pageSize: 30 }}
        defaultCurrent={30}
        loading={loading}
        total={leadsListFiltered?.pagination?.total}
        onChange={(pagination) => {
          let url = `leads?page=${pagination?.current}`
          fetchLeedsList(url)
        }}
        // pdfTableColumns={pdfTableColumns}
        pageSize={30}
      />
    </div>
  );
};
